import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UIButton from 'UIComponents/button/UIButton';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import { redirectToLogin } from '../actions/TwoFactorAuthActions';
import { getUserLoginRequired } from '../selectors/twoFactorAuth';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TwoFactorAuthLoginRequiredAlertContainer = props => {
  if (!props.userLoginRequired) {
    return null;
  }
  return /*#__PURE__*/_jsx(UIAlert, {
    className: "m-bottom-4",
    type: props.displayType,
    children: /*#__PURE__*/_jsxs(UIButtonWrapper, {
      children: [/*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "userPreferences.2fa.requiresUserLogin.text"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        onClick: () => props.redirectToLogin(),
        size: "extra-small",
        use: "tertiary-light",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "userPreferences.2fa.requiresUserLogin.loginButton"
        })
      })]
    })
  });
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
TwoFactorAuthLoginRequiredAlertContainer.defaultProps = {
  displayType: 'tip'
};
TwoFactorAuthLoginRequiredAlertContainer.prototypes = {
  displayType: PropTypes.string,
  userLoginRequired: PropTypes.bool.isRequired
};
const mapStateToProps = state => {
  return {
    userLoginRequired: getUserLoginRequired(state)
  };
};
export default connect(mapStateToProps, {
  redirectToLogin
})(TwoFactorAuthLoginRequiredAlertContainer);